// AUTO GENERATED FILE - Changes WILL be lost.
// id - used as 'id' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Betslip",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Pasang taruhan",
  "betslip.clear": "Hapus semua",
  "betslip.clearResult": "Hapus",
  "betslip.noSelections": "Tambahkan pilihan untuk memulai taruhan",
  "betslip.notLoggedIn": "Login untuk mulai taruhan",
  "betslip.refresh": "Refresh",
  "betslip.totalStake": "Total taruhan",
  "betslip.noHistoryData": "Tidak ada informasi taruhan yang tersedia",
  "betslip.openBets": "Taruhan Terbuka",
  "betslip.betHistory": "History Taruhan",
  "betslip.betHistoryWon": "Menang",
  "betslip.betHistoryLost": "Kalah",
  "loading.loading": "Memuat",
  "loading.account": "Memuat akun",
  "loading.league": "Memuat liga",
  "loading.gameweeks": "Memuat game week",
  "loading.markets": "Memuat pasar",
  "loading.bethistory": "Memuat history taruhan",
  "login.loginRequired": "Silakan Login",
  "login.loginToBet": "Silakan Login untuk mulai taruhan",
  "navigation.back": "Kembali",
  "navigation.close": "Tutup",
  "video.liveStreamAvailable": "Streaming live tersedia",
  "video.logInToWatch": "Silakan login untuk menyaksikan",
  "error.error": "Kesalahan",
  "error.404": "halaman tidak ditemukan",
  "error.gameLaunchFailed": "Tidak dapat meluncurkan game",
  "error.unknownErrorCode": "Kesalahan yang tidak diketahui: {code}",
  "error.minUnitStakeLimitExceeded": "Minimum taruhan adalah {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksimum taruhan adalah {limit}",
  "error.minTotalStakeLimitExceeded": "Minimum total taruhan adalah {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksimum total taruhan adalah {limit}",
  "error.notPlaced": "Tidak terpasang",
  "error.wagerDisallowed": "Taruhan tidak diperbolehkan",
  "error.errorEventIsOff": "Event telah dimulai",
  "multiplebet.Singles": "Singles",
  "multiplebet.Doubles": "Doubles",
  "multiplebet.Trebles": "Trebles",
  "multiplebet.Accumulator": "Accumulator",
  "multiplebet.Perm 4-Folds": "Perm 4-Folds",
  "multiplebet.Perm 5-Folds": "Perm 5-Folds",
  "multiplebet.Perm 6-Folds": "Perm 6-Folds",
  "multiplebet.Perm 7-Folds": "Perm 7-Folds",
  "multiplebet.Perm 8-Folds": "Perm 8-Folds",
  "multiplebet.Perm 9-Folds": "Perm 9-Folds",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATHENS",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLYMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIAS",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Tidak ada lagi taruhan",
  "playtime": "Waktu bermain",
  "gameId": "Game ID",
  "noGames": "Tidak ada game tersedia. Cek kembali nanti.",
  "Home": "Home",
  "Away": "Away",
  "Visitor": "Tamu",
  "soccerbet.gameWeek": "GAMEWEEK",
  "soccerbet.noGameWeeks": "Tidak ada game week yang tersedia. Silakan cek kembali nanti.",
  "soccerbet.league": "Klasemen Liga",
  "soccerbet.table.name": "Nama",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "D",
  "soccerbet.table.lost": "L",
  "soccerbet.table.points": "PT",
  "selection.Yes": "Ya",
  "selection.No": "Tidak",
  "selection.1+G": "1+G",
  "selection.1+Ng": "1+Ng",
  "selection.X+G": "X+G",
  "selection.X+Ng": "X+Ng",
  "selection.2+G": "2+G",
  "selection.2+Ng": "2+Ng",
  "selection.1+Yes": "1+Ya",
  "selection.1+No": "1+Tidak",
  "selection.X+Yes": "X+Ya",
  "selection.X+No": "X+Tidak",
  "selection.2+Yes": "2+Ya",
  "selection.2+No": "2+Tidak",
  "selection.U": "U",
  "selection.O": "O",
  "selection.1+O": "1+O",
  "selection.X+O": "X+O",
  "selection.2+O": "2+O",
  "selection.1+U": "1+U",
  "selection.X+U": "X+U",
  "selection.2+U": "2+U",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "sb-english.team.abbr.ARS": "ARS",
  "sb-english.team.abbr.AST": "AST",
  "sb-english.team.abbr.BHA": "BHA",
  "sb-english.team.abbr.BOU": "BOU",
  "sb-english.team.abbr.BUR": "BUR",
  "sb-english.team.abbr.CHE": "CHE",
  "sb-english.team.abbr.CRY": "CRY",
  "sb-english.team.abbr.EVE": "EVE",
  "sb-english.team.abbr.LEI": "LEI",
  "sb-english.team.abbr.LIV": "LIV",
  "sb-english.team.abbr.MNC": "MNC",
  "sb-english.team.abbr.MNU": "MNU",
  "sb-english.team.abbr.NEW": "NEW",
  "sb-english.team.abbr.SOU": "SOU",
  "sb-english.team.abbr.TOT": "TOT",
  "sb-english.team.abbr.WAT": "WAT",
  "sb-english.team.abbr.WHU": "WHU",
  "sb-english.team.abbr.WOL": "WOL",
  "sb-english.team.abbr.NOR": "NOR",
  "sb-english.team.abbr.SHU": "SHU",
  "sb-english.team.abbr.LEE": "LEE",
  "sb-english.team.abbr.FUL": "FUL",
  "sb-english.team.abbr.WBA": "WBA",
  "sb-italian.team.abbr.MIL": "MIL",
  "sb-italian.team.abbr.ATA": "ATA",
  "sb-italian.team.abbr.BOL": "BOL",
  "sb-italian.team.abbr.BRE": "BRE",
  "sb-italian.team.abbr.CAG": "CAG",
  "sb-italian.team.abbr.CHI": "CHI",
  "sb-italian.team.abbr.FIO": "FIO",
  "sb-italian.team.abbr.GEN": "GEN",
  "sb-italian.team.abbr.INT": "INT",
  "sb-italian.team.abbr.JUV": "JUV",
  "sb-italian.team.abbr.LAZ": "LAZ",
  "sb-italian.team.abbr.NAP": "NAP",
  "sb-italian.team.abbr.ROM": "ROM",
  "sb-italian.team.abbr.SAM": "SAM",
  "sb-italian.team.abbr.UDI": "UDI",
  "sb-italian.team.abbr.VER": "VER",
  "sb-greek.team.abbr.AEK": "AEK",
  "sb-greek.team.abbr.APS": "APS",
  "sb-greek.team.abbr.ARI": "ARI",
  "sb-greek.team.abbr.AST": "AST",
  "sb-greek.team.abbr.ATR": "ATR",
  "sb-greek.team.abbr.GIA": "GIA",
  "sb-greek.team.abbr.LEV": "LEV",
  "sb-greek.team.abbr.OFI": "OFI",
  "sb-greek.team.abbr.OLM": "OLM",
  "sb-greek.team.abbr.PTK": "PTK",
  "sb-greek.team.abbr.PNS": "PNS",
  "sb-greek.team.abbr.PAO": "PAO",
  "sb-greek.team.abbr.PLT": "PLT",
  "sb-greek.team.abbr.XAN": "XAN",
  "last60.team.ATL": "Atlanta Hawks",
  "last60.team.BKN": "Brooklyn Nets",
  "last60.team.BOS": "Boston Celtics",
  "last60.team.CHA": "Charlotte Hornets",
  "last60.team.CHI": "Chicago Bulls",
  "last60.team.CLE": "Cleveland Cavaliers",
  "last60.team.DAL": "Dallas Mavericks",
  "last60.team.DEN": "Denver Nuggets",
  "last60.team.DET": "Detroit Pistons",
  "last60.team.GSW": "Golden State Warriors",
  "last60.team.HOU": "Houston Rockets",
  "last60.team.IND": "Indiana Pacers",
  "last60.team.LAC": "LA Clippers",
  "last60.team.LAL": "Los Angeles Lakers",
  "last60.team.MEM": "Memphis Grizzlies",
  "last60.team.MIA": "Miami Heat",
  "last60.team.MIL": "Milwaukee Bucks",
  "last60.team.MIN": "Minnesota Timberwolves",
  "last60.team.NOP": "New Orleans Pelicans",
  "last60.team.NYK": "New York Knicks",
  "last60.team.OKC": "Oklahoma City Thunder",
  "last60.team.ORL": "Orlando Magic",
  "last60.team.PHI": "Philadelphia 76ers",
  "last60.team.PHX": "Phoenix Suns",
  "last60.team.POR": "Portland Trail Blazers",
  "last60.team.SAC": "Sacramento Kings",
  "last60.team.SAS": "San Antonio Spurs",
  "last60.team.TOR": "Toronto Raptors",
  "last60.team.UTA": "Utah Jazz",
  "last60.team.WAS": "Washington Wizards",
  "last60.team.abbr.ATL": "ATL",
  "last60.team.abbr.BKN": "BKN",
  "last60.team.abbr.BOS": "BOS",
  "last60.team.abbr.CHA": "CHA",
  "last60.team.abbr.CHI": "CHI",
  "last60.team.abbr.CLE": "CLE",
  "last60.team.abbr.DAL": "DAL",
  "last60.team.abbr.DEN": "DEN",
  "last60.team.abbr.DET": "DET",
  "last60.team.abbr.GSW": "GSW",
  "last60.team.abbr.HOU": "HOU",
  "last60.team.abbr.IND": "IND",
  "last60.team.abbr.LAC": "LAC",
  "last60.team.abbr.LAL": "LAL",
  "last60.team.abbr.MEM": "MEM",
  "last60.team.abbr.MIA": "MIA",
  "last60.team.abbr.MIL": "MIL",
  "last60.team.abbr.MIN": "MIN",
  "last60.team.abbr.NOP": "NOP",
  "last60.team.abbr.NYK": "NYK",
  "last60.team.abbr.OKC": "OKC",
  "last60.team.abbr.ORL": "ORL",
  "last60.team.abbr.PHI": "PHI",
  "last60.team.abbr.PHX": "PHX",
  "last60.team.abbr.POR": "POR",
  "last60.team.abbr.SAC": "SAC",
  "last60.team.abbr.SAS": "SAS",
  "last60.team.abbr.TOR": "TOR",
  "last60.team.abbr.UTA": "UTA",
  "last60.team.abbr.WAS": "WAS",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}"
}
